import { Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { DataCenterFileFilter as DataCenterFileFilterModel, DataCenterFileFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const DataCenterFileFilter = (props: {
  filter: DataCenterFileFilterModel;
  setFilter: (value: DataCenterFileFilterModel) => void;
}) => {
  const { breakpointsRef, fullFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<DataCenterFileFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.dataCenterFiles.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={fullFieldBreakpoints}>
        <Select
          multiple
          modelProperty={properties.find((x) => x.propertyName === pn<DataCenterFileFilterModel>("statusIds"))}
          value={resource.statuses?.filter((x) => props.filter.statusIds?.includes(x.id))}
          options={resource.statuses}
          getOptionLabel={(option) => option.name}
          onChange={(e, values) =>
            props.setFilter(
              produce(props.filter, (draft) => {
                draft.statusIds = values.map((x) => x.id);
              })
            )
          }
        />
      </Grid>

      <Grid item xs={fullFieldBreakpoints}>
        <Select
          multiple
          modelProperty={properties.find((x) => x.propertyName === pn<DataCenterFileFilterModel>("dataTypeIds"))}
          value={resource.dataTypes?.filter((x) => props.filter.dataTypeIds?.includes(x.id))}
          options={resource.dataTypes}
          getOptionLabel={(option) => option.name}
          onChange={(e, values) =>
            props.setFilter(
              produce(props.filter, (draft) => {
                draft.dataTypeIds = values.map((x) => x.id);
              })
            )
          }
        />
      </Grid>

      <Grid item xs={fullFieldBreakpoints}>
        <Select
          multiple
          modelProperty={properties.find((x) => x.propertyName === pn<DataCenterFileFilterModel>("contentIds"))}
          value={resource.contents?.filter((x) => props.filter.contentIds?.includes(x.id))}
          options={resource.contents}
          getOptionLabel={(option) => option.name}
          onChange={(e, values) =>
            props.setFilter(
              produce(props.filter, (draft) => {
                draft.contentIds = values.map((x) => x.id);
              })
            )
          }
        />
      </Grid>

      <Grid item xs={fullFieldBreakpoints}>
        <Select
          multiple
          modelProperty={properties.find((x) => x.propertyName === pn<DataCenterFileFilterModel>("schoolYears"))}
          value={resource.schoolYears?.filter((x) => props.filter.schoolYears?.includes(x.id))}
          options={resource.schoolYears}
          getOptionLabel={(option) => option.name}
          onChange={(e, values) =>
            props.setFilter(
              produce(props.filter, (draft) => {
                draft.schoolYears = values.map((x) => x.id);
              })
            )
          }
        />
      </Grid>

      <Grid item xs={fullFieldBreakpoints}>
        <Select
          modelProperty={properties.find(
            (x) => x.propertyName === pn<DataCenterFileFilterModel>("createdByClientUserId")
          )}
          value={resource.users?.find((x) => x.id === props.filter.createdByClientUserId)}
          options={resource.users}
          getOptionLabel={(option) => `${option.lastName}, ${option.firstName}`}
          onChange={(e, value) =>
            props.setFilter(
              produce(props.filter, (draft) => {
                draft.createdByClientUserId = value?.id;
              })
            )
          }
        />
      </Grid>
    </Grid>
  );
};
